// caiet UC21-07 (changed 2026-10-12), CF-28: what an inactivation stops and what it keeps, said
// the same way on the entity file and in the register, so neither asks with less (TC-UC21-07-01).
// per docs/shape-ops-registrar-kind-change-confirmation.md §2 D3
import { useTranslate } from '@tolgee/react';
import { MudInfoBox } from '@egov-moldova/mud-react';

export interface DeactivationEffectsProps {
  name: string;
  /** The Registrar System's credentials go down with it; said only where there are active ones. */
  credentialActive: boolean;
  siteCount: number;
}

export function DeactivationEffects({
  name,
  credentialActive,
  siteCount,
}: DeactivationEffectsProps): JSX.Element {
  const { t } = useTranslate();
  return (
    <MudInfoBox emphasis="strong" variant="warning">
      <strong>{name}</strong>{' '}
      {credentialActive
        ? t('registrar_detail.confirm.stops_with_credentials')
        : t('registrar_detail.confirm.stops')}{' '}
      {siteCount > 0
        ? t('registrar_detail.confirm.stays', { sites: siteCount })
        : t('registrar_detail.confirm.stays_no_sites')}
    </MudInfoBox>
  );
}
